var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82187 7.99952L1.58907 13.2323C1.26373 13.5577 1.26373 14.0851 1.58907 14.4104C1.9144 14.7358 2.44186 14.7358 2.7672 14.4104L8 9.17765L13.2328 14.4104C13.5581 14.7358 14.0856 14.7358 14.4109 14.4104C14.7363 14.0851 14.7363 13.5577 14.4109 13.2323L9.17813 7.99952L14.4104 2.7672C14.7358 2.44187 14.7358 1.9144 14.4104 1.58907C14.0851 1.26373 13.5576 1.26373 13.2323 1.58907L8 6.82138L2.76768 1.58907C2.44235 1.26373 1.91488 1.26373 1.58955 1.58907C1.26422 1.9144 1.26422 2.44187 1.58955 2.7672L6.82187 7.99952Z",
    fill: "#7B809A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/XIcon.4602adc561da78bb588bc4e2596133b8.svg";
export { ForwardRef as ReactComponent };